import React, { FC, useEffect, useState } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import FormBlock from 'src/components/FormBlock';
import Loading from 'src/components/Loading/intex';
import ConfirmDialog, { ConfirmDialogStatePropsType } from 'src/components/ConfirmDialog';
import { setLocationParams } from 'src/resources/location/reducer';
import {
    clearWebhookDeliveryDetail,
    getWebhookDeliveryDetailFetch,
} from 'src/resources/webhookDeliveryDetail/reducer';
import { retryWebhookDeliveryFetch } from 'src/resources/webhookDeliveriesGrid/reducer';
import { RootStoreType } from 'src/types/store';
import { useCheckPermission } from 'src/utils/checkPermission';
import AttemptHistorySection from './AttemptHistorySection';
import Detail from './Detail';
import TopBlock from './TopBlock';

const WebhookRecordDetailContainer: FC = () => {
    const dispatch = useDispatch();
    const { eventId } = useParams();
    const [confirmParams, setConfirmParams] = useState<ConfirmDialogStatePropsType | null>(null);

    const data = useSelector((state: RootStoreType) => state.webhookDeliveryDetail.data);
    const loading = useSelector((state: RootStoreType) => state.webhookDeliveryDetail.loading);
    const permissionUpdate = useCheckPermission('WEBHOOK.UPDATE');
    const backUrl = '/settings/webhook_records/';

    useEffect(() => {
        dispatch(
            setLocationParams({
                name: translate('webhookRecordDetail.title', { eventId: eventId || '' }),
                backUrl,
            })
        );
    }, [dispatch, eventId, backUrl]);

    useEffect(() => {
        if (eventId) {
            dispatch(getWebhookDeliveryDetailFetch(eventId));
        }
        return () => {
            dispatch(clearWebhookDeliveryDetail());
        };
    }, [dispatch, eventId]);

    const reload = () => {
        if (eventId) {
            dispatch(getWebhookDeliveryDetailFetch(eventId));
        }
    };

    const handleRetry = () => {
        if (!eventId) {
            return;
        }
        setConfirmParams({
            title: translate('webhookRecords.action.retry'),
            content: translate('webhookRecords.action.retryConfirm'),
            action: () => {
                dispatch(retryWebhookDeliveryFetch(eventId));
            },
        });
    };

    return (
        <div data-testid="webhook-record-detail">
            <TopBlock
                data={data}
                permissionUpdate={permissionUpdate}
                onReload={reload}
                onRetry={handleRetry}
            />
            {loading && <Loading />}
            {data && (
                <>
                    <FormBlock>
                        <Detail data={data} />
                    </FormBlock>
                    <AttemptHistorySection attempts={data.ATTEMPTS || []} />
                </>
            )}
            {confirmParams && (
                <ConfirmDialog
                    title={confirmParams.title}
                    content={confirmParams.content}
                    action={confirmParams.action}
                    onClose={() => setConfirmParams(null)}
                />
            )}
        </div>
    );
};

export default WebhookRecordDetailContainer;
